import { render, staticRenderFns } from "./video-calibrations.vue?vue&type=template&id=97e0856c&scoped=true"
import script from "./video-calibrations.vue?vue&type=script&lang=js"
export * from "./video-calibrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e0856c",
  null
  
)

export default component.exports